import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mvp_map.jpg")